import React, { createContext, ReactNode, useContext } from 'react';
import { StackModalContextType } from '../types';

export const StackModalContext = createContext<
  StackModalContextType | undefined
>(undefined);

interface StackModalProviderProps {
  children: ReactNode;
  value: StackModalContextType;
}

export const StackModalProvider: React.FC<StackModalProviderProps> = ({
  children,
  value,
}) => {
  return (
    <StackModalContext.Provider value={value}>
      {children}
    </StackModalContext.Provider>
  );
};

export const useStackModalContext = (): StackModalContextType => {
  const context = useContext(StackModalContext);

  if (context === undefined) {
    throw new Error(
      'useStackModalContext must be used within a StackModalProvider',
    );
  }

  return context;
};
